import api from './client'

// Fixed UUID representing the web dashboard as a "device"
export const WEB_DEVICE_ID = '00000000-0000-0000-0000-000000000001'

export interface Reading {
  id: string
  meter_id: string
  reader_id: string
  device_id: string
  reading_value: number
  reading_date: string
  notes: string | null
  synced: boolean
  version: number
  updated_at: string
}

export interface Meter {
  id: string
  subscriber_name: string
  address: string
  meter_serial: string
  meter_type: string | null
  latitude: number | null
  longitude: number | null
  installation_date: string | null
  notes: string | null
  active: boolean
  last_reading_value: number | null
  last_reading_date: string | null
  created_at: string
  reading_route_id: string | null
  reading_route_name: string | null
}

export interface MeterCreate {
  subscriber_name: string
  address: string
  meter_serial: string
  meter_type?: string
  latitude?: number
  longitude?: number
  installation_date?: string
  notes?: string
}

export interface MeterUpdate {
  subscriber_name?: string
  address?: string
  meter_type?: string
  // null, not just omission -- PUT /meters/{id} is exclude_unset
  // (meters-to-web-2026-09-21-patch-clear-nullable.md), whose own backend
  // comment uses clearing a mis-recorded GPS fix as its motivating case.
  latitude?: number | null
  longitude?: number | null
  notes?: string
  active?: boolean
}

export interface ReadingCreate {
  meter_id: string
  reading_value: number
  reading_date: string   // ISO datetime string
  notes?: string
}

export const readingsApi = {
  list: (params?: { meter_id?: string; since?: string; limit?: number; skip?: number }) =>
    api.get<Reading[]>('/readings', { params }),

  // bbox: minLng,minLat,maxLng,maxLat (WGS84) -- a viewport filter that
  // ignores skip/limit by design (meters-to-web-mobile-2026-09-27-geo-and-
  // bbox-contract.md); pass it alone, never alongside limit/skip.
  getMeters: (params?: { search?: string; active?: boolean; limit?: number; skip?: number; bbox?: string }) =>
    api.get<Meter[]>('/meters', { params }),

  getMeter: (id: string) =>
    api.get<Meter>(`/meters/${id}`),

  createMeter: (body: MeterCreate) =>
    api.post<Meter>('/meters', body),

  updateMeter: (id: string, body: MeterUpdate) =>
    api.put<Meter>(`/meters/${id}`, body),

  createReading: (body: ReadingCreate) =>
    api.post<Reading>('/readings', {
      meter_id:    body.meter_id,
      device_id:   WEB_DEVICE_ID,
      reading_value: body.reading_value,
      reading_date:  body.reading_date,
      notes:         body.notes,
      client_uuid:   crypto.randomUUID(),
    }),
}
